import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import Break from '../../../../../assets/icons/Break';
import AddItemMenu from '../../addItemMenu/AddItemMenu';
import * as css from './ActionsBar.css';

interface ActionsBarProps {
    onAddItem: () => void;
    onAddBreak?: () => void;
    disableBreak?: boolean;
}

function ActionsBar({onAddItem, onAddBreak, disableBreak}: ActionsBarProps) {
    const {t} = useTranslation('timetable');

    return (
        <css.actionsBar>
            <AddItemMenu
                text={t('addItemGrid')}
                variant="brand"
                placement="above"
                onAddLecture={onAddItem}
                onAddBreak={onAddBreak}
                disableBreak={disableBreak}
            />
            {(onAddBreak || disableBreak) && <Button variant="neutral" size="chip" iconStart={<Break />} onClick={onAddBreak} disabled={disableBreak}>{t('addBreak')}</Button>}
        </css.actionsBar>
    );
}

export default ActionsBar;
